






















































































import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import {
  DocumentRegistrationResult,
  IDocumentImageSource,
  Document,
  ExternalValidationResults,
} from "../../../domain/document";
import { IContentSource } from "../../../domain/drawing";
import {
  HisInfoSelectDialog,
} from "../../his/dialogs";
import {
  AuthenticationDialog,
} from "../../authentication/dialogs";
import { ModelEditableMixin } from "../../system/mixins";
import {
  ExtraDocumentSelectorDialog,
  ExtraPagePositionInputDialog,
} from "../dialogs";
import {
  AiPhraseDialog,
  AiSyntaxDialog,
  AiPreprocessDialog,
} from "../aiPhrase/dialogs";
import {
  ClipboardAdapter,
  FileViewerAdapter,
  ExternalScriptAdapter,
  ClaioAdapter,
  ClaioSchemaAdapter,
  MksTemplateAdapter,
  DynamicTemplateAdapter,
  ProRadDrawAdapter,
  SignAdapter,
} from "./adapters";
import { ClickChainAgent } from "./agents";
import {
  CommonDialogsAccessor,
  ExtraPageDialogsAccessor,
  PatientProfileDialogsAccessor,
  ReferenceFileDialogsAccessor,
  ApplicationDialogsAccessor,
  CommonEditorsAccessor,
  CommonOperatorsAccessor,
} from "./CommonComponentsAccessor";
import {
  ImageFileUploaderDialog,
  SignDialog,
  PrintPdfPreviewDialog,
  UserDefinitionSelectDialog,
  PatientProfileEditDialog,
  ReferenceFileSelectDialog,
  ApplicationLaunchDialog,
  MksTemplateSelectDialog,
  DynamicTemplateSelectDialog,
  ValueConfirmDialog,
} from "./dialogs";
import {
  PageEditor,
  ExtraPageEditor,
  HisInformationEditor,
  UserDefinitionEditor,
  PatientProfileEditor,
  DocumentImageSwapper,
} from "./editors";
import {
  DocumentValidator,
  DocumentPrinter,
  DocumentRegisterer,
} from "./operators";
import {
  ExtraInformationUpdatableMixin,
  DocumentAttributesEditableMixin,
} from "./mixins";
import {
  FuzzyDateSelectDialog,
  FuzzyTimeSelectDialog,
 } from "./objects/dialogs";
import { IDocumentEditMenuConfiguration } from "./contents";
import {
  TrimmingDialog,
} from "../../drawing/dialogs";

@Component({
  components: {
    ImageFileUploaderDialog,
    SignDialog,
    FuzzyDateSelectDialog,
    FuzzyTimeSelectDialog,
    PrintPdfPreviewDialog,
    ExtraDocumentSelectorDialog,
    ExtraPagePositionInputDialog,
    AiPhraseDialog,
    HisInfoSelectDialog,
    AuthenticationDialog,
    UserDefinitionSelectDialog,
    PatientProfileEditDialog,
    ReferenceFileSelectDialog,
    ApplicationLaunchDialog,
    MksTemplateSelectDialog,
    DynamicTemplateSelectDialog,
    PageEditor,
    ExtraPageEditor,
    HisInformationEditor,
    UserDefinitionEditor,
    PatientProfileEditor,
    DocumentValidator,
    DocumentPrinter,
    DocumentRegisterer,
    DocumentImageSwapper,
    ClipboardAdapter,
    FileViewerAdapter,
    ExternalScriptAdapter,
    ClaioAdapter,
    ClaioSchemaAdapter,
    MksTemplateAdapter,
    DynamicTemplateAdapter,
    ProRadDrawAdapter,
    ValueConfirmDialog,
    SignAdapter,
    ClickChainAgent,
    TrimmingDialog,
    AiSyntaxDialog,
    AiPreprocessDialog,
  }
})
export default class CommonComponentsContainer extends Mixins(
  ModelEditableMixin,
  ExtraInformationUpdatableMixin,
  DocumentAttributesEditableMixin,
) {
  @Prop()
  initializeNewExtraDocument: (extraDocument: Document, document: Document) => Promise<void>;

  @Prop()
  getExtraDocument: (patientId: string, formatId: number) => Promise<Document>;

  @Prop()
  register: (source: Document, isTemporary: boolean, isPublish: boolean) => Promise<DocumentRegistrationResult>;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  @Prop()
  getReferenceFile: (fileId: number | string) => Promise<IContentSource>;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  @Prop()
  createPreviewCacheSource: (document: Document) => Promise<IContentSource>;

  @Prop()
  userCode: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop({ default: false })
  shouldValidateAllPages: boolean;

  @Prop()
  editMenuConfiguration: IDocumentEditMenuConfiguration;

  @Prop()
  validateWithExternalValidationUrl: () => Promise<ExternalValidationResults>;

  @Emit()
  documentRegistered(id: number, destinationRoute: any, isTemporary?: boolean, archiveId?: number): any {}

  data() {
    return {
      extraPageEditor: null as ExtraPageEditor,
      documentValidator: null as DocumentValidator,
    };
  }
  extraPageEditor: ExtraPageEditor;
  documentValidator: DocumentValidator;

  mounted(): void {
    this.extraPageEditor = this.commonEditors.extraPage;
    this.documentValidator = this.commonOperators.validator;
  }

  get document(): Document {
    return this.readPropertyOrDefault(s => s.source, null);
  }

  get extraPageDialogs(): ExtraPageDialogsAccessor {
    return new ExtraPageDialogsAccessor(this);
  }  

  get commonDialogs(): CommonDialogsAccessor {
    return new CommonDialogsAccessor(this);
  }  

  get patientProfileDialogs(): PatientProfileDialogsAccessor {
    return new PatientProfileDialogsAccessor(this);
  }  

  get referenceFileDialogs(): ReferenceFileDialogsAccessor {
    return new ReferenceFileDialogsAccessor(this);
  }  

  get applicationDialogs(): ApplicationDialogsAccessor {
    return new ApplicationDialogsAccessor(this);
  }  

  get commonEditors(): CommonEditorsAccessor {
    return new CommonEditorsAccessor(this);
  }  

  get commonOperators(): CommonOperatorsAccessor {
    return new CommonOperatorsAccessor(this);
  }
}
